'use strict';

const saBubble = [
  function () {
    return {
      template: '<span class="Bubble">{{value}}</span>',
      replace: true,
      scope: {
        value: '='
      },
      link: function ($scope, $element) {
        function showElement() {
          $element.css('display', 'inline-block');
        }

        function hideElement() {
          $element.css('display', 'none');
        }

        hideElement();

        $scope.$watch('value', function (value) {
          if (angular.isNumber(value) && value > 0) {
            showElement();
          } else {
            hideElement();
          }
        });
      }
    };
  }
];

export default saBubble;



// WEBPACK FOOTER //
// ./app/src/directives/bubble.js